import { render, staticRenderFns } from "./AdminAppNotificationModal.vue?vue&type=template&id=555c4a75"
import script from "./AdminAppNotificationModal.vue?vue&type=script&lang=js"
export * from "./AdminAppNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./AdminAppNotificationModal.vue?vue&type=style&index=0&id=555c4a75&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555c4a75')) {
      api.createRecord('555c4a75', component.options)
    } else {
      api.reload('555c4a75', component.options)
    }
    module.hot.accept("./AdminAppNotificationModal.vue?vue&type=template&id=555c4a75", function () {
      api.rerender('555c4a75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminAppNotificationModal.vue"
export default component.exports